<section class="page-container">
  <div class="flex items-center justify-between">
    <h1 class="main-heading">
      PARF Transfer Date
    </h1>
    <app-navpath />
  </div>

  <div class="content-container">
    <h2 class="sub-heading w-full border-b">PARF Transfer Date</h2>
    <app-data-form
      [dataFields]="parfForm"
      (clickSearch)="handleSearch()"
    />
  </div>

  <div class="content-container">
    <h2 class="sub-heading w-full border-b">For Reference</h2>
    <app-data-form [dataFields]="referenceForm" class="border-b" />
    <div class="mt-4 flex w-fit gap-1">
      <button class="shorter-btn save-btn" (click)="update()">
        <fa-icon [icon]="faFloppyDisk" class="mr-1" />Update
      </button>
      <button class="shorter-btn clear-btn" (click)="clear()">
        <fa-icon [icon]="faEraser" class="mr-1" />Clear
      </button>
    </div>
  </div>
</section>
